import { useState } from "react";
import { BioShell, Field, ResultCard, Stat, primaryBtn, BIO_ACCENT } from "./BioShell.jsx";
import { hardyWeinbergFromP, hardyWeinbergFromAa, round } from "./biocore.js";

export default function HardyWeinberg() {
  const [mode, setMode] = useState("p");
  const [val, setVal] = useState("0.6");
  const [res, setRes] = useState(null);

  const run = () => {
    const x = parseFloat(val);
    if (isNaN(x)) { setRes({ ok: false, error: "Enter a number between 0 and 1" }); return; }
    setRes(mode === "p" ? hardyWeinbergFromP(x) : hardyWeinbergFromAa(x));
  };

  return (
    <BioShell title="Hardy-Weinberg">
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        p² + 2pq + q² = 1. Assumes equilibrium (no selection, drift, migration, mutation, random mating).
      </p>
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {[["p", "From allele freq p"], ["aa", "From aa frequency (q²)"]].map(([k, l]) => (
          <button key={k} onClick={() => { setMode(k); setRes(null); }} style={{ flex: 1, background: mode === k ? BIO_ACCENT : "#1C1E2E", color: mode === k ? "#04240F" : "#9A9DBE", border: "none", borderRadius: 10, padding: "10px 6px", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
            {l}
          </button>
        ))}
      </div>
      <Field label={mode === "p" ? "Allele frequency p (0–1)" : "Frequency of aa genotype (0–1)"} value={val} onChange={(e) => setVal(e.target.value)} inputMode="decimal" />
      <button onClick={run} style={primaryBtn}>Calculate</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label="p (dominant allele)" value={round(res.p, 4)} unit="" />
          <Stat label="q (recessive allele)" value={round(res.q, 4)} unit="" />
          <Stat label="AA (homozygous dom.)" value={round(res.AA, 4)} unit="" />
          <Stat label="Aa (heterozygous)" value={round(res.Aa, 4)} unit="" />
          <Stat label="aa (homozygous rec.)" value={round(res.aa, 4)} unit="" />
          {res.steps && (
            <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid #1C1E2E" }}>
              {res.steps.map((s, i) => (
                <div
                  key={i}
                  style={{
                    fontSize: 12.5,
                    color: i === res.steps.length - 1 ? "#9A9DBE" : "#C8CADF",
                    fontFamily: "ui-monospace, monospace",
                    padding: "3px 0",
                  }}
                >
                  {s}
                </div>
              ))}
            </div>
          )}
        </ResultCard>
      )}
    </BioShell>
  );
}

